import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-charcoal/80 leading-relaxed" data-id="element-24">
    <p className="text-sm text-charcoal/50" data-id="element-25">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-26">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-27">
      Cuando adquieres "El Escudo de los 3 Segundos", recopilamos únicamente la
      información necesaria para procesar tu compra y enviarte el producto
      digital: tu nombre y dirección de correo electrónico. Los datos de pago
      son procesados directamente por nuestras pasarelas de pago seguras y nunca
      son almacenados en nuestros servidores.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-28">
      2. Uso de tu Información
    </h3>
    <p data-id="element-29">Utilizamos tu información para:</p>
    <ul className="list-disc pl-6 space-y-1" data-id="element-30">
      <li data-id="element-31">Entregarte el producto digital adquirido a tu correo electrónico.</li>
      <li data-id="element-32">
        Enviarte actualizaciones, mejoras o material complementario relacionado
        con la guía.
      </li>
      <li data-id="element-33">Responder a consultas relacionadas con tu compra.</li>
    </ul>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-34">
      3. Protección de Datos
    </h3>
    <p data-id="element-35">
      Empleamos medidas técnicas y organizativas estándar de la industria para
      proteger tu información personal contra accesos no autorizados, alteración
      o divulgación. Todas las transacciones de pago se procesan a través de
      plataformas con encriptación de nivel bancario.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-36">
      4. Cookies
    </h3>
    <p data-id="element-37">
      Este sitio utiliza cookies esenciales para garantizar el correcto
      funcionamiento de la página y cookies analíticas anónimas para mejorar la
      experiencia del usuario. Puedes desactivarlas desde la configuración de tu
      navegador.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-38">
      5. Compartir Información con Terceros
    </h3>
    <p data-id="element-39">
      No vendemos, alquilamos ni compartimos tu información personal con
      terceros, excepto cuando es estrictamente necesario para procesar tu
      compra (pasarelas de pago) o cuando lo exija la ley.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-40">
      6. Tus Derechos
    </h3>
    <p data-id="element-41">
      Tienes derecho a acceder, corregir o solicitar la eliminación de tus datos
      personales en cualquier momento. También puedes darte de baja de nuestras
      comunicaciones a través del enlace presente en cada correo.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-42">
      7. Cambios en esta Política
    </h3>
    <p data-id="element-43">
      Nos reservamos el derecho de actualizar esta política de privacidad.
      Cualquier cambio será publicado en esta misma página.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-charcoal/80 leading-relaxed" data-id="element-44">
    <p className="text-sm text-charcoal/50" data-id="element-45">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-46">
      1. Aceptación de los Términos
    </h3>
    <p data-id="element-47">
      Al acceder a este sitio web y/o adquirir el producto "El Escudo de los 3
      Segundos", aceptas estar sujeto a estos Términos y Condiciones. Si no
      estás de acuerdo con alguna parte, te pedimos no realizar la compra.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-48">
      2. Naturaleza del Producto
    </h3>
    <p data-id="element-49">
      "El Escudo de los 3 Segundos" es un producto digital de carácter educativo
      e informativo, diseñado para ofrecer herramientas prácticas a madres que
      buscan mejorar su gestión emocional en la crianza. No sustituye en ningún
      caso la asesoría profesional psicológica, médica o terapéutica.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-50">
      3. Propiedad Intelectual
    </h3>
    <p data-id="element-51">
      Todo el contenido —textos, imágenes, guías, protocolos, checklists,
      diarios y guiones— es propiedad exclusiva del autor y está protegido por
      las leyes de derechos de autor. Queda estrictamente prohibido reproducir,
      distribuir, copiar, vender o compartir el material adquirido sin
      autorización expresa por escrito.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-52">
      4. Uso Personal
    </h3>
    <p data-id="element-53">
      La compra otorga al usuario una licencia personal, intransferible y no
      exclusiva para acceder al contenido. Está prohibido el uso comercial del
      material o su redistribución bajo cualquier forma.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-54">
      5. Pagos y Entrega
    </h3>
    <p data-id="element-55">
      El pago se realiza a través de plataformas seguras al momento de la
      compra. La entrega del producto digital es inmediata vía correo
      electrónico una vez confirmada la transacción. Es responsabilidad del
      usuario proporcionar un correo electrónico válido y revisar las carpetas
      de spam o promociones.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-56">
      6. Política de Reembolsos
    </h3>
    <p data-id="element-57">
      Dado que se trata de un producto digital de descarga inmediata, una vez
      entregado el material no se admiten devoluciones ni reembolsos, salvo en
      casos en los que el producto presente fallas técnicas que impidan su
      acceso y no puedan ser solucionadas.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-58">
      7. Limitación de Responsabilidad
    </h3>
    <p data-id="element-59">
      Los resultados mencionados en este sitio son referenciales y dependen del
      compromiso individual de cada lectora. No garantizamos resultados
      específicos. El autor no se hace responsable por interpretaciones o
      aplicaciones erróneas del contenido.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-60">
      8. Modificaciones
    </h3>
    <p data-id="element-61">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones entrarán en vigor desde su publicación en este
      sitio.
    </p>

    <h3 className="font-serif text-xl text-charcoal font-semibold pt-2" data-id="element-62">
      9. Legislación Aplicable
    </h3>
    <p data-id="element-63">
      Estos Términos y Condiciones se rigen por las leyes vigentes aplicables al
      comercio electrónico de productos digitales.
    </p>
  </div>;
export const Footer = () => {
  const [modal, setModal] = useState<ModalType>(null);
  useEffect(() => {
    if (modal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [modal]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setModal(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);
  return <>
      <footer className="bg-charcoal text-white/60 py-12 px-5 text-center" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <p className="font-serif text-xl text-white/80 mb-6" data-id="element-66">
            El Escudo de los 3 Segundos
          </p>
          <p className="text-sm mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-67">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-68">
            <button onClick={() => setModal('terms')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-69">
              Términos y Condiciones
            </button>
            <span className="text-white/20" data-id="element-70">•</span>
            <button onClick={() => setModal('privacy')} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-71">
              Política de Privacidad
            </button>
          </div>
          <p className="text-xs mt-12 opacity-50" data-id="element-72">
            &copy; {new Date().getFullYear()} El Escudo de los 3 Segundos. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-73">
        {modal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 bg-charcoal/60 backdrop-blur-sm flex items-center justify-center p-4 md:p-8" onClick={() => setModal(null)} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-74">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="bg-cream rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-75">
              <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-border bg-white" data-id="element-76">
                <h2 id="modal-title" className="font-serif text-2xl md:text-3xl font-bold text-charcoal" data-id="element-77">
                  {modal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setModal(null)} className="w-10 h-10 rounded-full hover:bg-beige flex items-center justify-center text-charcoal/60 hover:text-charcoal transition-colors" aria-label="Cerrar" data-id="element-78">
                  <X size={20} data-id="element-79" />
                </button>
              </div>

              <div className="overflow-y-auto px-6 md:px-8 py-6" data-id="element-80">
                {modal === 'privacy' ? privacyContent : termsContent}
              </div>

              <div className="px-6 md:px-8 py-4 border-t border-border bg-white text-right" data-id="element-81">
                <button onClick={() => setModal(null)} className="bg-terracotta hover:bg-[#B56A63] text-white font-medium px-6 py-2.5 rounded-full transition-colors text-sm" data-id="element-82">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};